import React from 'react';
import { useDispatch } from 'react-redux';
import AuthLoader from '@lendi-ui/auth-loader';

import { HYDRATION_STAGES } from '@funnels/constants';
import { Endpoints, useHydrateForClone } from '@funnels/hooks';
import { clearAllErrors } from '@funnels/redux-store';

interface HydrationProviderProps {
  children: React.ReactNode;
  value: Endpoints;
  hideAuthLoader?: boolean;
}

export function HydrationProviderForClone(props: HydrationProviderProps) {
  const stage = useHydrateForClone(props.value);
  const dispatch = useDispatch();
  // Clear all errors on hydration
  React.useEffect(() => {
    dispatch(clearAllErrors());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (stage !== HYDRATION_STAGES.HYDRATED) {
    if (!props.hideAuthLoader) {
      return <AuthLoader data-component="lui-auth-loader" />;
    }
    return null;
  }

  return props.children as any;
}
